import {useState} from 'react'
import axios from 'axios';

const projectID = 'cd860518-4f13-42f4-8648-f33db9919951';

const LoginForm = () =>
{
    const [username,setUserName] = useState('');
    const [password,setPassword]= useState('') ;

    const handleSubmit = async (e)=>
    {
        e.preventDefault();

        const authObj = {'Project-ID':projectID,'User-Name': username, 'User-Secret': password }

        try{
            await axios.get('https://api.chatengine.io/chats', { headers: authObj });
            localStorage.setItem('username', username);
            localStorage.setItem('password', password);

            window.location.reload();
      
        }
        catch(err){

        }

    }
    return (
        <div className="wrapper">
            <div className="form">
            <h1 className="title"> Safe Chat</h1>
            <form onSubmit={handleSubmit}>
                <input type="text" value={username} onChange={e=>{setUserName(e.target.value)}} className="input" placeholder='Username' required/>
                <input type="password" value={password} onChange={e=>{setPassword(e.target.value)}} className="input" placeholder='Password' required/>
                <div align="center">
                    <button type="submit" className='button'>
                        <span>Start Chat</span>
                    </button>
                </div>

            </form>
            </div>
        </div>
    )
}

export default LoginForm ;